import { defineMessages } from 'react-intl';

const messages = defineMessages({
  sectionHeaderForSsoAccountManagement: {
    description: 'section header for third party login',
    defaultMessage: 'Third Party Login',
    id: 'Cxl9k0',
  },
  sectionDescription: {
    description: 'section description for third party login',
    defaultMessage: 'Connect an external login service (like Google) to securely sign in with one click.',
    id: 'eN6nFF',
  },
  disconnect: {
    description: 'link text to disconnect the sso account',
    defaultMessage: 'Disconnect',
    id: 'eMzlJM',
  },
  connect: {
    description: 'link text to connect an sso account',
    defaultMessage: 'Connect',
    id: 'NElSGq',
  },
  connectedTo: {
    description: 'Email address to which the external account is connected',
    defaultMessage: 'Connected to: {email}',
    id: 'F9Q0j8',
  },
  externalAccountImageAltText: {
    description: 'External Account image',
    defaultMessage: 'External account image',
    id: 'iz+MB5',
  },
  unlinkSuccessTitle: {
    description: 'External Account: Successfully disconnected account title.',
    defaultMessage: 'Successfully Disconnected',
    id: '4/Nx0B',
  },
  unlinkSuccessMessage: {
    description: 'External Account: Successfully disconnected account message.',
    defaultMessage: 'To log in to ShipStation, use your ShipStation account username and password.',
    id: '/alEui',
  },
  unlinkErrorTitle: {
    description: 'title for notification alerting unlinking of accounts failed',
    defaultMessage: 'Failed to Disconnect',
    id: 'MmFnb9',
  },
  unlinkErrorMessage: {
    description: 'message explaining that unlinking failed',
    defaultMessage: 'Unable to disconnect this account. Please try again later.',
    id: 'HF6PGn',
  },
  fetchIdentitiesErrorMessage: {
    description: 'message explaining that fetching identities failed',
    defaultMessage: 'Error getting identities',
    id: 'hUMFEv',
  },
  linkErrorTitle: {
    description: 'title for notification alerting linking of accounts failed',
    defaultMessage: 'Failed to Connect',
    id: 'FFQxx+',
  },
  linkErrorMessage: {
    description: 'message explaining that linking failed',
    defaultMessage: 'Unable to connect this account. Please try again later.',
    id: 'iZL/BK',
  },
  unlinkConfirmationWarningMessage: {
    description: 'warning for all users about disconnecting this identity provider from ShipStation',
    defaultMessage: 'You will no longer be able to sign in to ShipStation using your {idpName} account.',
    id: '7XMwp9',
  },
  unlinkConfirmationWarningForNativeSsoSellerMessage: {
    description: 'ensure the user really means to sever the SSO connection (special addendum for native SSO sellers)',
    defaultMessage:
      'Have you set a password for this user? If you have not done so, this user will not be able to log in to ShipStation. You can set a password by logging out and then clicking “Forgot Password” on the sign in page.',
    id: 'UQ4anm',
  },
  unlinkConfirmationMessage: {
    description: 'ensure the user really means to sever the SSO connection',
    defaultMessage: 'Are you sure you want to disconnect “{email}” ({idpName}) from your ShipStation account?',
    id: 'X9wFHV',
  },
  unlinkConfirmationTitleMessage: {
    description: 'the title for the disconnect confirmation modal',
    defaultMessage: 'Disconnect from {idpName}',
    id: 'UGFmVx',
  },
  unlinkDoubleConfirmationTitleMessage: {
    description: 'the title for the second disconnect confirmation modal',
    defaultMessage: 'Are you sure?',
    id: 'G1VIRQ',
  },
  accountLinkingBetaOptInMessage: {
    description: 'instructions on how to participate in the SSO account linking beta',
    defaultMessage: 'You can now link ShipStation to your Google account for easier sign in!',
    id: 'EVytGA',
  },
  accountLinkingBetaOptInNote: {
    description: 'a question asking if a user wants to participate in the SSO account linking beta',
    defaultMessage: 'Click “Opt in” to try it now.',
    id: '67klL7',
  },
  authBetaOptInButtonMessage: {
    description: 'opt in button text for auth beta features',
    defaultMessage: 'Opt in',
    id: 'Y56Z+u',
  },
  authBetaOptInConfirm: {
    description: 'message stating user understand opt in conditions',
    defaultMessage:
      'By clicking “Opt in”, you are enabling account linking and acknowledge that you understand and accept the associated terms and conditions.',
    id: 'l46xAs',
  },
  authBetaPleaseNote: {
    description: 'section header for beta opt in notes',
    defaultMessage: 'Please note:',
    id: 'ew0R1d',
  },
  accountLinkingComingSoonMessage: {
    description: 'tiny blurb noting that account linking is coming soon; part 1',
    defaultMessage: 'SSO is almost here!',
    id: 'yQfRI1',
  },
  accountLinkingComingSoonNote: {
    description: 'tiny blurb noting that account linking is coming soon; part 2',
    defaultMessage: "You'll be able to link your Google account to ShipStation for a faster, more secure login experience. Stay tuned...",
    id: '/iw0H+',
  },
  accountLinkingOptInExplainer: {
    description: 'message explaining what account linking does and how to re-enable if lost',
    defaultMessage:
      'When you enable account linking, you’ll see a new set of controls on your profile page that allow you to connect your Google account to ShipStation. Once connected, you can then sign in to ShipStation using your Google account instead of manually entering your ShipStation username and password.',
    id: 'FBfSxV',
  },
  accountLinkingOptInExplainerNote1: {
    description: 'note that this opt in applies only to this machine / browser and each new machine / browser requires new opt in',
    defaultMessage: 'If you use multiple browsers or devices, you’ll need to opt in separately for each one.',
    id: 'T05zFD',
  },
  accountLinkingOptInExplainerNote2: {
    description: 'note that this opt in is persisted in cookies',
    defaultMessage:
      'The enabled status is stored using cookies. If the Google login option is no longer visible for any reason, just return to this page and enable again.',
    id: 'yJUnzM',
  },
});

export default messages;
